import { render, staticRenderFns } from "./ComponentView.vue?vue&type=template&id=b13a8724"
import script from "./ComponentView.vue?vue&type=script&lang=js"
export * from "./ComponentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports